<template>
  <div class="mobileChatLayout">
    <div
      class="industryChatPanel el-loading-mask"
      v-if="loading"
      style="height: 100%; display: flex; align-items: center"
    >
      <div style="width: 100%; text-align: center">
        <img src="../../assets/statics/mobile-load.gif" style="width: 100px" />
        <span
          style="
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            display: block;
            width: 100%;
            text-align: center;
          "
          >生成中..</span
        >
      </div>
    </div>
    <div class="industryChatPanel">
      <div class="ceMetaIndustryChatHeader" v-if="!loading && !generating">
        <i class="el-icon-close close" @click="closeChatPage" />
      </div>
      <div class="chatBodyPanel" id="contentEle">
        <div
          class="industryChatContentPanel"
          :key="index"
          v-for="(item, index) in copywritingList"
        >
          <!-- 打星 保存 -->
          <div class="industryHeadTools">
            <!-- <div style="align-items: center; justify-content: center">
              <el-rate
                v-model="item.star"
                @change="setArticleStar(index)"
              ></el-rate>
            </div> -->
            <div
              style="
                padding: 4px 8px;
                margin-right: 6px;
                font-size: 16px;
                background: #efefef;
              "
            >
              No.{{ index + 1 }}
            </div>
            <span
              style="padding: 4px 8px; font-size: 14px; background: #efefef"
              >{{
                "字数：" +
                (!generating && !item.editStatus
                  ? item.contentWords.length
                  : "---")
              }}</span
            >
          </div>

          <div
            v-if="item.editStatus === true"
            class="industryChatContent"
            style="padding-top: 24px; padding-bottom: 24px"
          >
            <el-input
              :disabled="!!generating"
              type="textarea"
              v-model="item.editContentWords"
              autosize
              class="editingContent"
            />
          </div>
          <div v-else class="industryChatContent">
            {{ item.contentWords }}
          </div>

          <div
            v-show="!generating && !item.editStatus"
            class="chatSplitLine"
          ></div>
          <div class="industryChatTools">
            <div class="chattoolsItemStyle" style="text-align: center">
              <!-- <el-button
                v-show="!generating && !item.editStatus"
                type="text"
                @click="exportAsWord(index)"
                >导出为word</el-button
              > -->
              <el-button
                v-show="!generating && !item.editStatus"
                class="normalButton withSpacing"
                @click="setArticleStar(index, true)"
              >
                <img
                  v-if="item.agree === 'up'"
                  class="rate"
                  src="../../assets/statics/up.png"
                />
                <img
                  v-else
                  src="../../assets/statics/down.png"
                  class="rate rotate"
                />
                赞
              </el-button>
              <el-button
                v-show="!generating && !item.editStatus"
                class="normalButton withSpacing"
                @click="setArticleStar(index, false)"
              >
                <img
                  v-if="item.agree === 'down'"
                  src="../../assets/statics/up.png"
                  class="rate rotate"
                />
                <img v-else class="rate" src="../../assets/statics/down.png" />
                踩
              </el-button>
              <el-button
                v-show="!generating && !item.editStatus"
                class="normalButton withSpacing"
                @click="editArticleContent(index)"
              >
                编辑文案
              </el-button>
              <el-button
                v-show="!generating && !item.editStatus"
                class="normalButton withSpacing copy_btn"
                @click="copyContent(index)"
                :data-clipboard-text="item.contentWords"
              >
                一键复制
              </el-button>
              <el-button
                v-show="item.editStatus"
                class="normalButton"
                @click="revertArticleContent(index)"
              >
                取消
              </el-button>
              <el-button
                v-show="item.editStatus"
                @click="finishEditArticleContent(index)"
                class="normalButton"
              >
                保存
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          margin-top: 17px;
          text-align: center;
          position: sticky;
          bottom: 0px;
          background: #fff;
          padding: 16px 0;
        "
      >
        <el-button
          v-if="!loading && !!generating"
          @click="stopGeneratArticle"
          class="normalButton"
        >
          停止生成
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
export default {
  data() {
    return {};
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    generating: {
      type: Boolean,
      required: true,
      default: false,
    },
    closeChatPage: {
      type: Function,
      required: true,
      default: null,
    },
    stopGeneratArticle: {
      type: Function,
      required: true,
      default: null,
    },
    copywritingList: {
      type: Array,
      required: true,
      default: [],
    },
    editArticleContent: {
      type: Function,
      required: true,
      default: [],
    },
    revertArticleContent: {
      type: Function,
      required: true,
      default: [],
    },
    finishEditArticleContent: {
      type: Function,
      required: true,
      default: [],
    },
    setArticleStar: {
      type: Function,
      required: true,
      default: [],
    },
  },
  methods: {
    async copyContent(index) {
      const copyObj = new Clipboard(".copy_btn");

      copyObj.on("success", async () => {
        this.$message.success("复制成功");
        copyObj.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mobileChatLayout {
  z-index: 1000;
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .chatBodyPanel {
    background: #d8d8d8;
  }

  .ceMetaIndustryChatHeader {
    padding: 16px 20px;
    display: block;
    width: 100%;
    height: 32px;
    .close {
      float: right;
    }
  }

  .industryChatContentPanel {
    padding: 16px 20px;
    background: #fff;
    margin-top: 12px;

    .industryHeadTools {
      display: flex;
      justify-content: flex-start;
      height: 50px;
      align-items: center;
      width: 100%;
      border-bottom: solid 1px #d8d8d8;
    }

    .industryChatContent {
      font-size: 14px;
      color: #111d3a;
      outline: none;
      text-align: justify;
      line-height: 30px !important;
      box-sizing: border-box;
      font-weight: 400;
      letter-spacing: 0;
      font-family: SourceHanSansCN-Regular;
      white-space: pre-line;
    }
  }
  .chattoolsItemStyle {
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
  }

  .normalButton {
    border-radius: 1.5rem;
    height: 2.5rem;
    background-color: #e0e0e0;
    width: 7rem;
    color: #000000;

    &.withSpacing {
      width: unset;
      margin-top: 12px;
      margin-left: 0;
      padding: 4px 12px;
    }
  }

  /deep/ .el-textarea__inner {
    background: #f5f7fb;
    border: unset;
  }
  .chatSplitLine {
    width: 100%;
    height: 0.1vw;
    background-color: rgb(192, 192, 202);
    margin-top: 8px;
  }
  .rate {
    margin-right: 4px;
  }
  .rotate {
    transform: rotateX(180deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobileChat/GeneralChat.vue